import { LocalStorageKeys } from 'javascript/Constants'
import { useCookieConsentStore } from 'Store/cookie-consent'

class InMemoryStorage {
  storage = {}

  setItem(key, value) {
    this.storage[key] = value
  }

  getItem(key) {
    return this.storage[key]
  }

  removeItem(key) {
    delete this.storage[key]
  }

  clear() {
    this.storage = {}
  }
}

let storage = new InMemoryStorage()

const setStorage = () => {
  try {
    localStorage.getItem('test')
    storage = localStorage
  } catch (e) {
    // do nothing
  }
}

setStorage()

const functionalSettings = [
  LocalStorageKeys.CLOSED_ICON_MESSAGES,
  LocalStorageKeys.CHAT_ICON_MINIZED,
  LocalStorageKeys.SELECTED_CHAT_CHANNEL,
  LocalStorageKeys.TERMS_CONDITIONS_ACCEPTED
]

const triplaLocalStorage = {
  setItem(key, value, force = false) {
    if (functionalSettings.includes(key) && !force) {
      const cookieConsentStore = useCookieConsentStore()
      if (!cookieConsentStore.isFunctionalCookieEnabled) return
    }

    storage.setItem(key, value)
  },

  getItem(key) {
    return storage.getItem(key)
  },

  removeItem(key) {
    storage.removeItem(key)
  },

  clear() {
    storage.clear()
  }
}

export default triplaLocalStorage
